import React from 'react';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import { useLocation } from '@reach/router';

type SeoTypes = {
  description?: string;
  lang?: string;
  meta?: [];
  link?: [{ rel: string; href: string }];
  title?: string;
  ogImage?: string;
  canonical?: string;
  pageName?: string;
};

const Seo: React.FC<SeoTypes> = ({ description, lang, meta, link, title, ogImage, canonical, pageName }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            titles {
              uireview
              prototyping
            }
            description
            author
            ogImage
          }
        }
      }
    `
  );

  const location = useLocation();

  const metaTitles = site.siteMetadata.titles;
  const metaDescription = description || site.siteMetadata.description;
  const metaData = [
    {
      name: `description`,
      content: metaDescription,
    },
    {
      property: 'og:site_name',
      content: metaTitles[pageName] ? metaTitles[pageName] : `${title}`,
    },
    {
      property: `og:title`,
      content: metaTitles[pageName] ? `${title} | ${metaTitles[pageName]}` : `${title}`,
    },
    {
      property: `og:image`,
      content: ogImage || site.siteMetadata.ogImage,
    },
    {
      property: `og:url`,
      content: canonical || `https://${process.env.GATSBY_DOMAIN}${location.pathname}`,
    },
    {
      property: `og:description`,
      content: metaDescription,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:creator`,
      content: site.siteMetadata.author,
    },
    {
      name: `twitter:title`,
      content: title,
    },
    {
      name: `twitter:description`,
      content: metaDescription,
    },
  ].concat(meta || []);

  const linkData = [
    {
      rel: `canonical`,
      href: canonical || `https://${process.env.GATSBY_DOMAIN}${location.pathname}`,
    },
  ].concat(link || []);

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={title}
      titleTemplate={ metaTitles[pageName] ? `%s | ${metaTitles[pageName]}` : `%s`}
      meta={metaData}
      link={linkData}
    >
      <script type="application/javascript">
        {`{
          (function(d) {
            var config = {
              kitId: "${process.env.TYPEKIT_ID}",
              scriptTimeout: 3000,
              async: true
            },
            h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
          })(document);
        }`}
      </script>
      <script id="_bownow_ts">
        {`
          var _bownow_ts = document.createElement(\"script\");
          _bownow_ts.charset = \"utf-8\";
          _bownow_ts.src = \"https://contents.bownow.jp/js/UTC_419a824d6659449f5adf/trace.js\";
          document.getElementsByTagName(\"head\")[0].appendChild(_bownow_ts);
        `}
      </script>
    </Helmet>
  );
};

export default Seo;
